<script setup>
const props = defineProps({
  entity: { type: Object, required: true },
  fields: { type: Array, required: true }
});
</script>
<template>
  <dl class="entity-fields">
    <template v-for="field in fields" :key="field.name">
      <dt v-if="field.name != 'name'">
        {{ field.label }}
      </dt>
      <dd v-if="field.name != 'name'">
        {{ entity[field.name] || '' }}
      </dd>
    </template>
  </dl>
</template>
